import styled from 'styled-components';

export const Content = styled.div`
  position: relative;
  margin-left: 20px;
  min-width: 600px;
  height: auto;
  flex-grow: 1;
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.5);
`;
